import { environment } from '../../environments/environment';

export const UrlCacheWhiteList: Array<string> = [
    `${environment.apiEndPoint}/api/clients`,
    `${environment.apiEndPoint}/api/clients/filter`
];

